export default __webpack_public_path__ + "static/media/EM0750.34I-23429_-17727_0.f93c4bc0.jpg";